import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { fetchPendingStaffAsync } from '../thunks/validatePendingStaffThunk';
import { STATUS, UserData } from './userDetailslice';
import { updateUserStatusAsync } from '../thunks/userThunk';

export interface ResponseData {
  data: UserData[];
  page: number;
  size: number;
  totalCount: number;
}




export interface validatePendingStaffData {
  validatingPendingStaff: ResponseData | null;
  loading: boolean;
  status:string,
  error: string | null;
  updateStatusErrorMsg:string |null;
  updateStatus:string
}
const validatePendingStaffState: validatePendingStaffData = {
  validatingPendingStaff: null,
  status:STATUS.IDLE,
  loading: false,
  error: null,
  updateStatusErrorMsg:null,
  updateStatus:STATUS.IDLE
};

const validatePendingStaff = createSlice({
  name: "ValidatePendingStaff",
  initialState: validatePendingStaffState,
  reducers: {
    resetStatus(state) {     
        state.status = STATUS.IDLE; // Reset status to 'idle'    
  },
  resetUpdateStatusErrorMsg(state){
    state.updateStatusErrorMsg=null
    state.updateStatus=STATUS.IDLE
  },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchPendingStaffAsync.pending, (state) => {
        state.loading = true; // Set loading to true when fetching starts
        state.error = null; // Reset error state
      })
      .addCase(fetchPendingStaffAsync.fulfilled, (state, action) => {
        state.validatingPendingStaff = action.payload;
        state.loading = false; // Set loading to false when fetching is successful
      })
      .addCase(fetchPendingStaffAsync.rejected, (state, action) => {
        state.loading = false; // Set loading to false when fetching fails
        state.error = action.error.message ?? null; // Update error state
      })
      .addCase(updateUserStatusAsync.pending, (state) => {
        state.updateStatus=STATUS.LOADING
        state.error = null; // Reset error state
      })
      .addCase(updateUserStatusAsync.fulfilled, (state, action) => {
        state.updateStatus=STATUS.SUCCESS
      })
      .addCase(updateUserStatusAsync.rejected, (state, action) => {
        state.updateStatus=STATUS.FAILED
        state.updateStatusErrorMsg = action.error.message ?? null; // Update error state
      });
  },
});
export const { resetStatus,resetUpdateStatusErrorMsg } = validatePendingStaff.actions;
export default validatePendingStaff.reducer;

